type Environment = "local" | "staging" | "production";

type Configuration = {
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
  };
  sentry: {
    dsn: string;
    enabled: boolean;
    tracesSampleRate: number;
    replaysSessionSampleRate: number;
    replaysOnErrorSampleRate: number;
  };
};

const configurations: Record<Environment, Configuration> = {
  local: {
    auth0: {
      domain: "instaproc-local.us.auth0.com",
      clientId: "J8IZWaa2KA4N62prICw2fcb6zNMIIZaT",
      audience: "https://instaproc.local",
    },
    sentry: {
      dsn: import.meta.env.VITE_SENTRY_DSN,
      enabled:false,
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
    },
  },
  staging: {
    auth0: {
      domain: "instaproc-staging.us.auth0.com",
      clientId: "qhTWXDumTsEYUubHCmuD2EJQtfV1MiNj",
      audience: "https://instaproc.staging",
    },
    sentry: {
      dsn: import.meta.env.VITE_SENTRY_DSN,
      enabled: true,
      tracesSampleRate: 0.5,
      replaysSessionSampleRate: 0.5,
      replaysOnErrorSampleRate: 1.0,
    },
  },
  production: {
    auth0: {
      domain: "sure-steps.us.auth0.com",
      clientId: "jo4fbSFQVcZTMM8yDV2VqsfGM2BVbqDb",
      audience: "https://sure-steps.app",
    },
    sentry: {
      dsn: import.meta.env.VITE_SENTRY_DSN,
      enabled: true,
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    },
  },
};

const env = import.meta.env.VITE_ENV as Environment;
export const config = configurations[env];
